








































import Vue from 'vue';
import Preloader from '@/components/preloader/Preloader.vue';

export default Vue.extend({
  name: 'Button',
  components: {Preloader},
  
  props: {
    type: {
      type: String,
      default: 'button',
    },
    view: {
      type: String,
      default: 'primary',
    },
    color: {
      type: String,
      default: 'action',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    dataTestId: {
      type: String,
      required: false,
      default: ''
    },
    loader: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    viewButton(): string {
      return this.loader ? 'secondary' : this.view
    }
  }
});
